module.exports = __webpack_public_path__ + "static/media/orcl-dark-circular.b5945ca1.png";